import React from "react";
import { Popup, Icon } from "semantic-ui-react";

export default function FlowScreenshotButton({ onCapture, className = "" }) {
  return (
    <div className={`custom-screenshot-btn-fc ${className}`.trim()}>
      <Popup
        content="Tomar screenshot"
        position="top center"
        size="tiny"
        inverted
        trigger={
          <Icon
            circular
            name="camera"
            color="blue"
            className="custom-screenshot-btn screenshot-icon"
            onClick={onCapture}
            aria-label="Tomar screenshot del flujo de caja"
          />
        }
      />
    </div>
  );
}
